import { render, staticRenderFns } from "./EnvironmentWarning.vue?vue&type=template&id=127009ef&scoped=true&"
import script from "./EnvironmentWarning.vue?vue&type=script&lang=js&"
export * from "./EnvironmentWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127009ef",
  null
  
)

export default component.exports